import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const COLLECTION_LINK_SELECTOR = '[data-collection-link]'

export class ProductBreadcrumbs extends BaseComponent {
  setCollectionPage = (collectionPage: string): void => {
    if (collectionPage) {
      const link: HTMLLinkElement = $el(COLLECTION_LINK_SELECTOR, this)

      if (link) {
        const data = JSON.parse(collectionPage)

        link.href = data.url
        link.ariaLabel = data.title
        link.textContent = data.title
      }
    }
  }
}
